import React from 'react';

interface ICircleCheckIcon {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string;
  border?: string;
}

const CircleCheckIcon = ({ width, height, fillColor, strokeColor, border }: ICircleCheckIcon) => {
  return (
    <svg
      width={width || '20'}
      height={height || '20'}
      style={{ border, borderRadius: '100%' }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill={fillColor || '#5941A9'} />
      <path
        d="M14.6663 6.5L8.24967 12.9167L5.33301 10"
        stroke={strokeColor || 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke={fillColor || '#5941A9'} />
    </svg>
  );
};

export default CircleCheckIcon;
